<!--
 * @Description:
 * @Author: xz
 * @Date: 2023-06-16 14:08:25
 * @LastEditTime: 2023-06-21 10:52:50
 * @LastEditors: xz
-->
<template>
    <div id="pieChart" style="height: 400px; width: 600px;"></div>
</template>

<script>
import * as echarts from "echarts";
export default {
    props : {
        className: {
            type: String,
            default: 'chart'
        },
        width: {
            type: String,
            default: '100%'
        },
        height: {
            type: String,
            default: '100%'
        },
        intiData: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            option : {
                grid: {
                    left: 0,
                    // containLabel: true,
                    bottom: 0,
                    top: 0,
                    right: 0 //也可设置left和right设置距离来控制图表的大小
                },
                legend: {
                    type: 'scroll',
                    orient: 'vertical',
                    x: 'left',
                    data: [],
                    textStyle: {
                        // color: '#fff'
                    },
                    pageTextStyle: {
                        // color: '#fff'
                    }
                },
                tooltip: {
                    trigger: 'item'
                },
                series: [
                    {
                        type: 'pie',
                        data: [],
                        // radius: ['50%', '70%'],
                        radius: '70%',
                        avoidLabelOverlap: false,
                        label: {
                            show: true,
                            formatter: '{c}',
                            // position: 'center',
                            fontSize: '20'
                        },
                        labelLine: {
                            // length:30,
                            // length2:30,
                            show: false
                        },
                        color:['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'],
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: '30'
                                // fontWeight: 'bold'
                            }
                        },
                    }
                ]
            },
            // chart:null
        };
    },
    watch: {
        $props: {
            handler(val, oldvalue) {
                //console.log("val",val,"oldvalue",oldvalue)
                // if (this.chart) {
                //     this.chart.dispose();
                // }
                this.initChart();
            },
            deep: true,
        },
    },
    mounted() {
        this.initChart();
    },
    methods:{
        initChart() {
            let myChart=echarts.init(document.getElementById("pieChart"));
            let dataList = this.$props.intiData;
            let legendData = []
            dataList.forEach(element => {
                legendData.push(element.name)
            });
            this.option.legend.data=legendData
            this.option.series[0].data=dataList
            myChart.setOption(this.option);
        },
    }
};
</script>
<style scoped>
</style>
  


// WEBPACK FOOTER //
// src/components/dataSource/chart/pieChart.vue